/**
 * Export Page
 */

import { useState } from "react";
import { exportApi, ExportFilters } from "@/lib/exportApi";

export function ExportPage() {
  const [filters, setFilters] = useState<ExportFilters>({});
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleCsvExport = async () => {
    setIsExporting(true);
    setError(null);
    setSuccess(null);
    try {
      const blob = await exportApi.downloadCsv(filters);
      const today = new Date().toISOString().split("T")[0];
      exportApi.downloadFile(blob, "beoordelingen-" + today + ".csv");
      setSuccess("CSV export succesvol");
    } catch (e) {
      setError("CSV export mislukt");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Beoordelingen Exporteren</h1>
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-lg font-semibold mb-4">Filters</h2>
        <div className="grid grid-cols-2 gap-4">
          <select value={filters.status || ""} onChange={(e) => setFilters({...filters, status: e.target.value || undefined})} className="border rounded px-3 py-2">
            <option value="">Alle statussen</option>
            <option value="draft">Concept</option>
            <option value="finalized">Definitief</option>
          </select>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        {error && <div className="mb-4 text-red-600">{error}</div>}
        {success && <div className="mb-4 text-green-600">{success}</div>}
        <button onClick={handleCsvExport} disabled={isExporting} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50">
          {isExporting ? "Exporteren..." : "Download CSV"}
        </button>
      </div>
    </div>
  );
}
